import type { SelectOption } from '@movingimage-evp/mi-ui-component-library';
import type { TextInputProps } from '@movingimage-evp/mi-ui-component-library/types/components/text-input/text-input';
import type { ChangeEvent } from 'react';

import { Select } from '@movingimage-evp/mi-ui-component-library';
import countries from 'i18n-iso-countries';
import deLocale from 'i18n-iso-countries/langs/de.json';
import enLocale from 'i18n-iso-countries/langs/en.json';
import frLocale from 'i18n-iso-countries/langs/fr.json';
import itLocale from 'i18n-iso-countries/langs/it.json';
import { prioritizeCountries } from 'src/utils';
import { useSelectedLanguage } from 'src/viewer/providers/selected-language-provider';

countries.registerLocale(enLocale);
countries.registerLocale(deLocale);
countries.registerLocale(frLocale);
countries.registerLocale(itLocale);

export function CountrySelect({ value, onChange, ...props }: TextInputProps) {
  const { selectedLanguage } = useSelectedLanguage();

  const countryNames = Object.entries(countries.getNames(selectedLanguage?.code || '', { select: 'official' }));
  const countryNamesSorted = countryNames.sort((a, b) => a[1].localeCompare(b[1]));
  const countryNamesPrioritized = prioritizeCountries(countryNamesSorted, ['DE']);

  const options = countryNamesPrioritized.map(([key, label]) => ({ key, label }));
  const selectedOption = options.find(({ key }) => key === value);

  const handleChange = (option: SelectOption) => {
    const event = {
      target: { name: props.name, value: option.key },
    } as ChangeEvent<HTMLInputElement>;

    onChange?.(event);
  };

  return (
    <Select
      isSearchable
      optionsIdProperty="key"
      value={selectedOption}
      options={options}
      onChange={handleChange}
      {...props}
    />
  );
}
